import React from 'react';
import { usePagination, DOTS } from '../../hooks/usePagination';
import { ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon } from "components/icons";
import { Button } from "components";

import './index.scss';


const Pagination = props => {

    const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
        className
    } = props;

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    if (currentPage === 0 || paginationRange.length < 2) {
        return null;
    }

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    let lastPage = paginationRange[paginationRange.length - 1];

    return (
        <div className={`paylixecommerce-pagination-container ${className}`}>
            <Button variant="secondary" disabled={currentPage === 1} className="paylixecommerce-pagination-item" onClick={onPrevious}>
                <ChevronLeftIcon/>
            </Button>

            {paginationRange.map(pageNumber => {
                if (pageNumber === DOTS) {
                    return <Button variant="secondary" disabled={true} className="paylixecommerce-pagination-item dots">&#8230;</Button>;
                }

                return (
                    <Button variant="secondary" className={`paylixecommerce-pagination-item ${pageNumber === currentPage ? 'selected' : ''}`} onClick={() => onPageChange(pageNumber)}>
                        {pageNumber}
                    </Button>
                );
            })}

            <Button variant="secondary" disabled={currentPage === lastPage} className="paylixecommerce-pagination-item" onClick={onNext}>
                <ChevronRightIcon />
            </Button>
        </div>
    );
};

export default Pagination;